// Kid intro: the tablet hand-off (HOP-24).

import { MaskedName } from '@/lib/privacyMask'
import '@/styles/placement-flow.css'
import './styles/TransitionScreen.css'

interface TransitionScreenProps {
  learnerName: string
  onContinue: () => void
}

export function TransitionScreen({ learnerName, onContinue }: TransitionScreenProps) {
  return (
    <div className="transition-screen">
      <div className="transition-screen__header">
        <span className="hs-eyebrow transition-screen__eyebrow">
          Reading together · just for fun
        </span>
      </div>

      <div className="transition-screen__body">
        <div className="transition-screen__stack" aria-hidden="true">
          <div className="transition-screen__stack-shadow" />
          <div className="transition-screen__stack-card transition-screen__stack-card--back" />
          <div className="transition-screen__stack-card transition-screen__stack-card--middle" />
          <div className="transition-screen__stack-card transition-screen__stack-card--front">
            <span className="transition-screen__question-mark">?</span>
          </div>
        </div>

        <h1 className="transition-screen__title">
          We&rsquo;ll show some words, one at a time. For each one, tell us: can <MaskedName>{learnerName}</MaskedName> read
          it?
        </h1>
        <p className="transition-screen__copy">
          Sounding it out slowly{' '}
          <span className="transition-screen__highlight">
            <span aria-hidden="true" className="transition-screen__highlight-mark" />
            <span className="transition-screen__highlight-text">totally counts!</span>
          </span>
        </p>

        <button
          type="button"
          onClick={onContinue}
          className="hs-press hs-press--blue tr-continue-btn transition-screen__continue"
        >
          Continue
          <svg
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
            stroke="#fff"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M3 10h13M11 4l6 6-6 6" />
          </svg>
        </button>
      </div>
    </div>
  )
}
